import type { RatingSummaryResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { requestKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useRatingSummary(enabled: boolean) {
  return useQuery<RatingSummaryResponse>({
    enabled,
    queryFn: () => apiClient.url("/requests/ratings/summary").get().json(),
    queryKey: requestKeys.ratingSummary(),
  });
}
